import { render } from "./favorite-btn.vue?vue&type=template&id=0c3ef77c"
import script from "./favorite-btn.vue?vue&type=script&lang=js"
export * from "./favorite-btn.vue?vue&type=script&lang=js"

import "./favorite-btn.vue?vue&type=style&index=0&id=0c3ef77c&lang=scss"

import exportComponent from "/tmp/build_ed238492/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__